<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/A4PRK4/tc-custom/9781788787413.jpg?1685327173890" alt="This image is the cover for the book Kicking Goals"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Kicking Goals
      </h1>
      <p class="bookDescription body article font2">
        <p>Jack lives on a farm in southern New Zealand. He's the youngest of five children, is shy and doesn't like school. When there's time between chores, he plays rugby with his three brothers in the paddock in front of the house. One day, he has a dream which changes his life forever.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Shirley Deuchrass
      </h2>
      
      <p class="authorDescription body article">Shirley Deuchrass was born in Dunedin, New Zealand, and grew up on a farm in South Otago. She was educated in Dunedin, where she developed a love for writing. Although her first career path was nursing, she gained a BA in English at Otago University in 2003 and began writing in earnest.<br>Many of her poems grace the pages of Blackmail Press, PoetryNZ and Takahe magazines. A collection of poems was published in a book in 2010 titled River Calls Me Home.<br>Shirley’s writing history includes a self-published children’s novel called Isabella’s Diary in 2005 and several biographical titles.<br>She is married, with four children and seven grandchildren and currently lives in Wanaka, New Zealand.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7e26ffdb